export default __webpack_public_path__ + "static/media/Intro5.25e93c23.mp3";